import { render, staticRenderFns } from "./tSaleSearch.vue?vue&type=template&id=1d48aa6d&scoped=true"
import script from "./tSaleSearch.vue?vue&type=script&lang=js"
export * from "./tSaleSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48aa6d",
  null
  
)

export default component.exports